var _linearGradient, _polygon, _linearGradient2, _path, _linearGradient3, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyicon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    baseProfile: "basic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "X8la0xiHhT_0PDMuXdv25a",
    x1: 28.994,
    x2: 39.484,
    y1: 16.994,
    y2: 27.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#262626",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626",
    stopOpacity: 0.8
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#X8la0xiHhT_0PDMuXdv25a)",
    points: "39,22 36,22 36,19 34,19 34,22 31,22 31,24 34,24 34,27 36,27 36,24 39,24"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "X8la0xiHhT_0PDMuXdv25b",
    x1: 3.706,
    x2: 30.412,
    y1: 8.714,
    y2: 35.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#262626",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626",
    stopOpacity: 0.8
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#X8la0xiHhT_0PDMuXdv25b)",
    d: "M27.815,22.2l-0.05-0.2H19v3h5.91c-0.477,2.837-2.938,5-5.91,5c-3.314,0-6-2.686-6-6 s2.686-6,6-6c1.5,0,2.868,0.554,3.92,1.465l2.151-2.106C23.471,15.894,21.34,15,19,15c-4.971,0-9,4.029-9,9s4.029,9,9,9s9-4.029,9-9 C28,23.383,27.934,22.782,27.815,22.2z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "X8la0xiHhT_0PDMuXdv25c",
    x1: -1.154,
    x2: 62.754,
    y1: 9.477,
    y2: 46.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#262626",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626",
    stopOpacity: 0.8
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#X8la0xiHhT_0PDMuXdv25c)",
    d: "M24,4C12.954,4,4,12.954,4,24c0,11.046,8.954,20,20,20s20-8.954,20-20 C44,12.954,35.046,4,24,4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyicon1);
export default __webpack_public_path__ + "static/media/myicon1.0afb54abe58db44604642b47a0c24e62.svg";
export { ForwardRef as ReactComponent };